import { Quotes, Star } from "@phosphor-icons/react";
import { TESTIMONIALS } from "../lib/brand";

export default function Testimonials() {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="py-20 sm:py-28 border-t border-white/10 bg-[var(--rc-surface)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10 sm:mb-14">
          <div>
            <div className="label-eyebrow mb-3">[ Avaliações ]</div>
            <h2 className="font-display font-bold text-white text-3xl sm:text-5xl tracking-tight">
              Quem vende metal<br />
              <span className="text-[var(--rc-copper-bright)]">indica a Ricatto.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3 text-zinc-300">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={20} weight="fill" className="text-[var(--rc-copper-bright)]" />
              ))}
            </div>
            <span className="font-mono-ui text-sm">5,0 · cliente real</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[var(--rc-bg)] p-7 sm:p-8 flex flex-col justify-between gap-6"
            >
              <Quotes size={28} weight="fill" className="text-[var(--rc-copper-bright)]/70" />
              <blockquote className="text-zinc-100 leading-relaxed text-base">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="border-t border-white/10 pt-4">
                <div className="font-display font-bold text-white">{t.name}</div>
                <div className="text-xs text-zinc-500 font-mono-ui tracking-wider uppercase mt-1">
                  {t.where}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
